import { lazy } from 'react';

const DefaultRoute = '/booking';

// By default all routes except /login require authentication unless property public = true
const Routes = [
  // {
  //   path: '/npm',
  //   component: lazy(() => import('../../views/Landing')),
  //   public: true,
  // },
  {
    path: '/',
    component: lazy(() => import('../../views/HomePage')),
    public: true,
  },
  {
    path: '/terms-and-conditions',
    component: lazy(() => import('../../views/misc/Terms')),
    public: true,
    // layout: 'BlankLayout',
  },
  {
    path: '/refund-policy',
    component: lazy(() => import('../../views/misc/Refund')),
    public: true,
  },
  {
    path: '/choose-location',
    component: lazy(() => import('../../views/Booking/public/tabs/ChooseLocation')),
    public: true,
  },
  {
    path: '/availability/:specialistSlug/:providerSlug',
    component: lazy(() => import('../../views/Booking/public/tabs/Availability')),
    public: true,
  },
  {
    path: '/availability',
    component: lazy(() => import('../../views/Booking/public/tabs/Availability')),
    public: true,
  },
  {
    path: '/email-verification',
    component: lazy(() => import('../../views/misc/emailVerification')),
    public: true,
  },
  {
    path: '/faqs',
    component: lazy(() => import('../../views/misc/Faq')),
    public: true,
  },
  {
    path: '/contact-us',
    component: lazy(() => import('../../views/misc/ContactUs')),
    public: true,
  },
  {
    path: '/profile',
    component: lazy(() => import('../../views/Profile')),
  },
  {
    path: '/booking',
    component: lazy(() => import('../../views/Booking')),
  },
  {
    path: '/booking/success',
    component: lazy(() => import('../../views/Booking/tabs/Success')),
  },
  {
    path: '/payment/success',
    component: lazy(() => import('../../views/Booking/Payment/Success')),
  },
  {
    path: '/payment/cancel',
    component: lazy(() => import('../../views/Booking/Payment/error')),
  },
  {
    path: '/appointments',
    component: lazy(() => import('../../views/Appointments')),
  },
  {
    path: '/appointment/:id',
    component: lazy(() => import('../../views/Appointments/Details')),
  },
  // {
  //   path: '/confirmation/:id',
  //   component: lazy(() => import('../../views/Appointments/Confirm')),
  //   public: true,
  // },
  {
    path: '/appointment/results/:id',
    component: lazy(() => import('../../views/Appointments/Results')),
  },
  {
    path: '/dashboard',
    component: lazy(() => import('../../views/Dashboard')),
  },
  {
    path: '/second-page',
    component: lazy(() => import('../../views/SecondPage')),
  },
  {
    path: '/login',
    component: lazy(() => import('../../views/authentication/Login')),
    // layout: 'BlankLayout',
    public: true,
  },
  {
    path: '/verify',
    component: lazy(() => import('../../views/authentication/TwoFactor')),
    // layout: 'BlankLayout',
    public: true,
  },
  {
    path: '/forgot-password',
    component: lazy(() => import('../../views/authentication/ForgotPassword')),
    // layout: 'BlankLayout',
    public: true,
  },
  {
    path: '/register',
    component: lazy(() => import('../../views/authentication/Register')),
    // layout: 'BlankLayout',
    public: true,
  },
  {
    path: '/reset-password',
    component: lazy(() => import('../../views/authentication/ResetPassword')),
    // layout: 'BlankLayout',
    public: true,
  },
  // {
  //   path: '/feedback',
  //   component: lazy(() => import('../../views/Feedback')),
  //   public: true,
  // },
];

export { DefaultRoute, Routes };
